// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__KCawu","loaderinner":"style_loaderinner__iV1NX"};